import { useTheme, useMediaQuery } from '@mui/material';

export const useDisplaySize = () => {
    const theme = useTheme();

    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const isBetweenSmallAndMedium = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isBetweenMediumAndLarge = useMediaQuery(theme.breakpoints.between('md', 'lg'));
    const isBetweenLargeAndExtraLarge = useMediaQuery(theme.breakpoints.between('lg', 'xl'));

    const cardsPerPage =
        isSmall ? 1 :
        isBetweenSmallAndMedium ? 2 :
        isBetweenMediumAndLarge ? 3 :
        isBetweenLargeAndExtraLarge ? 4 : 5;

    return {
        isSmall,
        isBetweenSmallAndMedium,
        isBetweenMediumAndLarge,
        isBetweenLargeAndExtraLarge,
        cardsPerPage,
    };
};
